export default __webpack_public_path__ + "static/media/ram_madir_donation_project-1.39daef94.png";